export const focusAreas = [
    {id:1 ,name:"Communication"},
    {id:2 ,name:"Language & Grammar"},
    {id:3 ,name:"Product / Process Knowledge"},
    {id:4 ,name:"Troubleshooting & Problem Solving"},
    {id:5 ,name:"Probing & Questioning"},
    {id:6 ,name:"Call / Contact Handling"},
    {id:7 ,name:"Customer Experience"},
    {id:8 ,name:"Accuracy & Attention to Detail"},
    {id:9 ,name:"Policy & Compliance"},
    {id:10 ,name:"Systems & Tools"},
    {id:11 ,name:"Knowledge Base Usage"},
    {id:12 ,name:"Documentation"},
    {id:13 ,name:"Productivity & Efficiency"},
    {id:14 ,name:"Quality / QA"},
    {id:15 ,name:"Ownership & Accountability"},
    {id:16 ,name:"Emotional / Behavioral Skills"},
    {id:17 ,name:"Attendance & Adherence"},
    {id:18 ,name:"Sales / Retention (where applicable)"},
    {id:19 ,name:"Security & Risk"},
    {id:20 ,name:"Career / Professional Development"}
]

